<template>
    <div    class="">
        <div    v-if="hasNotifications"
                class="hidden sm:min-w-64 sm:flex flex-col justify-center px-4 py-4 sm:px-6">
            <div    class="my-1">
                <!-- Notifications Not Enabled -->
                <div    v-if="!hasNotificationsEnabled"
                        class="flex">
                    <!-- Heroicon name: solid/x-circle -->
                    <svg class="shrink-0 mr-1.5 h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                    </svg>
                    <span>Notifications Not Enabled.</span>
                </div>
                <div    v-else-if="hasANotificationMethod"
                        class="flex">
                    <svg class="shrink-0 mr-1.5 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                    <span>Notifications Enabled</span>
                </div>
                <div    v-else>
                    <!-- Heroicon name: solid/x-circle -->
                    <svg class="shrink-0 mr-1.5 h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                    </svg>
                    <span>Notifications Not Setup</span>
                </div>
            </div>
            <div    v-if="hasNotificationsEnabled"
                    class="flex my-1">
                <span   v-if="notifications.sms > 0"
                    :class="iconSMS" class="ml-4"></span>
                <span   v-if="notifications.voice > 0"
                    :class="iconVoiceMail" class="mx-8"></span>
                <span   v-if="notifications.email > 0"
                    :class="iconEmail" class="mr-4"></span>
                <span   v-if="notifications.push > 0"
                    :class="iconPushNotification" class="mr-4"></span>
            </div>
        </div>
        <div    v-else>
            <span   class="pl-4">
                -
            </span>
        </div>
    </div>
</template>

<script>
import {iconNamesMixin} from '@/mixins/IconNamesMixin';

export default {
    name: "UserNotificationsShow",
    mixins: [iconNamesMixin],
    components: {},
    props: {
        notifications: Object
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
    computed: {
        hasNotifications() {
            return !_.isNil(this.notifications)
        },
        hasNotificationsEnabled() {
            return this.notifications.notification_enabled
        },
        hasANotificationMethod() {
            if (_.isNil(this.notifications)) {
                return false
            }
            let notif = this.notifications
            return  notif.sms > 0 || notif.email > 0 || notif.voice > 0 || notif.push > 0
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>